<template>
  <md-field>
    <md-select v-model="selectedMonth">
      <md-option v-for="m in months" :key="m.value" :value="m.value">{{
        m.text
      }}</md-option>
    </md-select>
  </md-field>
</template>
<script>
import moment from 'moment'

/**
 * 月選択ドロップダウン(月度用)
 * 指定された開始月から終了月までを持つドロップダウンを作成します。
 */
export default {
  props: {
    /**
     * リスト作成の最小年月
     */
    minMonth: {
      required: true,
      type: String,
      validator(value) {
        return new RegExp(/^\d{6}$/g).test(value)
      },
    },
    /**
     * リスト作成の最大年月
     */
    maxMonth: {
      required: true,
      type: String,
      validator(value) {
        return new RegExp(/^\d{6}$/g).test(value)
      },
    },
    /**
     * 選択されている月
     */
    value: {
      type: String,
      validator(value) {
        return new RegExp(/^\d{6}$/g).test(value)
      },
    },
  },
  computed: {
    selectedMonth: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value + '01')
      },
    },
    /**
     * 降順に月リストを作成する。表示テキストは「yyyy年mm月」。
     */
    months() {
      const from = moment(this.minMonth, 'YYYYMM')
      const to = moment(this.maxMonth, 'YYYYMM')
      const diff = to.diff(from, 'months') + 1

      if (diff < 0) {
        throw new Error('Invalid dateFrom and dateTo')
      }

      let current = to
      const months = []

      for (let i = 0; i < diff; i++) {
        months.push({
          value: current.format('YYYYMM'),
          text: current.format('YYYY年M月'),
        })
        current = current.subtract(1, 'months')
      }
      return months
    },
  },
}
</script>
